export const teqip1=[
    {
        'sno':'1',
        'detail':'Civil Works',
        'amount':'132'
    },
    {
        'sno':'2',
        'detail':'Equipments',
        'amount':'1105.1'
    },
    {
        'sno':'3',
        'detail':'Furniture',
        'amount':'32'
    },
    {
        'sno':'4',
        'detail':'Books and LRs',
        'amount':'137.5'
    },
    {
        'sno':'5',
        'detail':'Consultant Services and Research Studies',
        'amount':'0.83'
    },
    {
        'sno':'6',
        'detail':'Training /Study Tours/Workshops',
        'amount':'19.2'
    },
    {
        'sno':'7',
        'detail':'Consumables',
        'amount':'26.3'
    },
    {
        'sno':'8',
        'detail':'Operation and Maintenance',
        'amount':'35.2'
    },
    {
        'sno':'9',
        'detail':'Networking of Institutions',
        'amount':'30'
    },
    {
        'sno':'10',
        'detail':'Service to the community',
        'amount':'30'
    },
    {    
        'sno':'Total',
        'amount':'1548.13'

    }

]